<template>
  <DownloadMediaModal />
</template>

<script>
import DownloadMediaModal from '@/Redesign/Components/DownloadMedia/DownloadMediaModal.vue'
import useDownloadMedia from '@/Redesign/Compositions/useDownloadMedia'

export default {
  components: {
    DownloadMediaModal
  },
  setup() {
    const { initializeBlock } = useDownloadMedia()

    initializeBlock(window.materialBlockTranslations)
  }
}
</script>
